import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// -----------------transaction-List-Api-------------------------
export const transactionListApi = async (data) => {
  const endPoint = `/admin/users/transaction?${new URLSearchParams(data)}`;
  return await axios.get(endPoint, setJwtToken());
};

// -----------------payment-List-Api-------------------------
export const paymentListApi = async (data) => {
  const endPoint = `/admin/users/payment?${new URLSearchParams(data)}`;
  return await axios.get(endPoint, setJwtToken());
};

// -----------download-File-Api----------------
export const downloadPaymentFileApi1 = async (data) => {
  const endPoint = `/admin/users/payment/export?${new URLSearchParams(data).toString()}`;
  return await axios.get(endPoint, { ...setJwtToken(), responseType: 'blob', });
};

// ✅ Fixed
export const downloadPaymentFileApi = async (data) => {
  const endPoint = `/admin/users/payment/export?${new URLSearchParams(data).toString()}`;
  return await axios.get(endPoint, { ...setJwtToken() }); // ❌ removed responseType: 'blob'
};